import dayjs from "dayjs";
import {
  CabinClass,
  FlightsSortOptions,
  SortOrder,
  TripType,
} from "./types/enums";
import { type FlightsSortValue } from "./types/types";

export const initialFlightsValues = {
  tripType: TripType.ONE_WAY,
  from: null,
  to: null,
  dates: {
    departure: dayjs().startOf("day").toDate(),
    return: dayjs().startOf("day").toDate(),
  },
  cabinClass: CabinClass.ECONOMY,
  adult: 1,
  child: 0,
  infantWithoutSeat: 0,
};

export const initialSortValue: FlightsSortValue = {
  field: FlightsSortOptions.PRICE,
  order: SortOrder.ASC,
};
